import React from "react";
import styles from "./Preloader.module.scss";
function index() {
  return (
    <div className={styles.preloader}>
      <div className={styles["animated-background"]}>
        <div
          className={`${styles["btn-divide-left"]}`}
        ></div>
      </div>
    </div>
  );
}

export default index;
